import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductPageReviews } from "@omni/types/components/product/productPage/reviews.type";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { useMemo } from "react";

import * as TrackingProductMapper from "@/services/tracking/mappers/product.mapper";
import { useImpressionTracking } from "@/utils/hooks/tracking/useImpressionTracking.hook";

type Props = {
    product: Product<ProductFieldSet.Full>;
    reviews?: ProductPageReviews;
};

export const useProductPageImpressionTracking = ({
    product,
    reviews
}: Props) => {
    const percentRecommended = useMemo(() => {
        const wouldRecommend =
            reviews?.reviewsSummary?.recommendation.wouldRecommend ?? 0;
        const wouldNotRecommend =
            reviews?.reviewsSummary?.recommendation.wouldNotRecommend ?? 0;

        const reviewersCount = wouldRecommend + wouldNotRecommend;

        if (reviewersCount === 0) return;

        return (wouldRecommend / reviewersCount) * 100;
    }, [reviews?.reviewsSummary?.recommendation]);

    const { ref } = useImpressionTracking({
        [EventType.ProductDetailImpression]: {
            ...TrackingProductMapper.toProductImpression(product),
            reviewCount: reviews?.reviewsSummary?.summary.count,
            reviewAverage: reviews?.reviewsSummary?.summary.average,
            reviewPercentRecommended: percentRecommended
        }
    });

    return { ref };
};
